import { inject, injectable } from 'inversify';
import * as FileSaver from "file-saver";

import { HttpService } from "src/core/services/http.service";

@injectable()
export class ImageService {
	@inject(HttpService)
	private httpService: HttpService;

	private baseUrl = 'api/v1/images';

	public async getImagesFrom(containerId: string) {
		let response = await this.httpService.post(`${this.baseUrl}/getImagesFrom`, {
			containerId: containerId,
			fileName: null,
			mimeType: null,
			buffer: null
		});
		let result = response.data as ImageGallery[];
		return result;	
	}
	convertToString(file: Uint8Array):string {
		let str = '';
		if (file != null && file.length > 0) {

			for (let i = 0; i < file.length; i++) {
				str += String.fromCharCode(file[i]);
			}

		}
		
		return btoa(str);
	}
	public async addImage(containerId: string, fileName: string, mimeType: string, buffer: Uint8Array, visibility: VisibilityItem, title:string) {
		let response = await this.httpService.post(`${this.baseUrl}/addImage`, {
			containerId: containerId,
			fileName: fileName,
			mimeType: mimeType,
			strByteArray: this.convertToString(buffer),
			visibility: visibility,
			title:title
		});
		let image = response.data as ImageGallery;
		return image;
	}

	public async removeImage(containerId: string, fileName: string, mimeType?: string, buffer?: Uint8Array) {
		let response = await this.httpService.post(`${this.baseUrl}/removeImage`, {
			containerId: containerId,
			fileName: fileName,
			mimeType: null,
			buffer: null
		});
		let successful = response.data as boolean;
		return successful;
	}
}



// WEBPACK FOOTER //
// ./src/app/shared/image.service.ts